import { createGuardedSelector } from '~/src/Store/utils'

import { isRoomDashboardRoute } from './urls'

export const createRoomDashboardReactor = kwargs => createGuardedSelector({
  ...kwargs,
  guardDependencies: ['selectRouteInfo'],
  guardFn: isRoomDashboardRoute,
})
